export enum PaymentmethodEnum {
  billet = 'Boleto',
  credit_card = 'Cartão de Crédito',
  bank_check = 'Cheque',
  deposit = 'Depósito',
  money = 'Dinheiro',
  pix = 'PIX'
}
